import React from 'react';
import { Provider } from 'react-redux';
import Reviews from '../components/reviews/Reviews';
import taggingDataStore from '../store/taggingDataStore';
import { ReviewsProps } from "../components/reviews/Context";

function ReviewsRoot(props) {
    return (
        <Provider store={taggingDataStore}>
            <ReviewsProps.Provider value={props}>
                <Reviews props={props} />
            </ReviewsProps.Provider>
        </Provider>
    );
}

ReviewsRoot.displayName = 'ReviewsRoot';

export default ReviewsRoot;